import React from 'react';

/**
 * Footer
 */
class Footer extends React.Component {
  render() {
    return (
      <footer id="footer">
        <div id="footerWrap" className="clearfix">
          <p className="copyright-txt">Copyright © 2018 KITADENSHI CORPORATION All rights reserved.</p>
          <ul className="info-link-list">
            <li><a href={FOOTER_COMMON_USER_GUIDE_URL} target="_blank">ユーザーガイド</a></li>
            <li><a href="/pdf/riyoukiyaku.pdf" target="_blank">利用規約</a></li>
            <li><a href="/pdf/dousakankyou.pdf" target="_blank">動作環境一覧</a></li>
          </ul>
        </div>
      </footer>
    );
  }
}

export default Footer;
